export const OperationSamples = [
  {
    'operation': "+",
    'description': "sum"
  },
  {
    'operation': "-",
    'description': "sub"
  },
  {
    'operation': "/",
    'description': "division"
  },
  {
    'operation': "*",
    'description': "mul"
  },
  {
    'operation': ">, <, ==",
    'description': "logical operations"
  },
  {
    'operation': "(({1} > {2} )? 1 : 2)",
    'description': "condition"
  },
  {
    'operation': "Math.max({1}, {2})",
    'description': "max"
  },
  {
    'operation': "Math.min({1}, {2})",
    'description': "min"
  },
  {
    'operation': "({0} > {1}) || ({1} == {0})",
    'description': ">="
  },
  {
    'operation': "({0} < {1}) || ({1} == {0})",
    'description': "<="
  }
]
